/*@ngInject*/
module.exports = function() {
    return {
        scope: {
            articles: '=',
            isScrollable: '=',
            isHomeView: '=',
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
            let vm = this;

            const nrOfArticlesDisplayed = 50;
            vm.nrOfShowedArticles = nrOfArticlesDisplayed;

            vm.showMore = () => {
                if (vm.nrOfShowedArticles < vm.articles.length) {
                    vm.nrOfShowedArticles += nrOfArticlesDisplayed;
                }
            };
        },
        template: require('./articles-list.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/accesssibility/directives/articles-list.directive.js
 **/